/** Filenames injected by Vite `define` from public/blog/images. */
function bakedBlogImageNames(): readonly string[] {
  return typeof __PUBLIC_BLOG_IMAGES__ !== 'undefined' ? __PUBLIC_BLOG_IMAGES__ : [];
}

/**
 * True when a root-relative /blog/images file is in the public folder.
 * External URLs are treated as present. A missing local file should render a
 * placeholder instead of an image request.
 */
export function publicBlogImageExists(src: string | null | undefined): boolean {
  if (!src) return false;

  let path = src;
  if (src.startsWith('http://') || src.startsWith('https://')) {
    try {
      const url = new URL(src);
      const host = url.hostname.toLowerCase();
      if (host !== 'milkywayplanner.com' && host !== 'www.milkywayplanner.com') return true;
      path = url.pathname;
    } catch {
      return false;
    }
  }

  if (!path.startsWith('/blog/images/')) return true;
  const name = decodeURIComponent(path.slice('/blog/images/'.length));
  if (!name || name.includes('/')) return false;
  return bakedBlogImageNames().includes(name);
}

export function missingFeaturedImageLabel(src: string): string {
  const name = src.split('/').pop() || src;
  return `PLACEHOLDER: hero image, Eric to provide (${name})`;
}
